import { useMediaQuery } from "@mui/material";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { secondary } from "../../../theme/colors";
import EditIcon from "../../../assets/images/edit-icon.svg";
export var JobCardInvoiceReturnInvoiceSummary = function () {
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var detailsTab = [{
            type: FormItemTypes.ContainerItem,
            name: "",
            columnSize: 12,
            margin: "16px 12px 16px 12px",
            elements: [{
                    type: FormItemTypes.Typography,
                    name: '',
                    value: 'Return Invoice Summary',
                    columnSize: 12,
                    fontWeight: 'strong'
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'Paid Amount',
                    label: '',
                    value: null,
                    columnSize: 12,
                    sx: {
                        bgcolor: secondary[50],
                        borderRadius: '8px'
                    },
                    summary: [{
                            type: FormItemTypes.Typography,
                            name: 'paidAmount',
                            label: '',
                            value: null,
                            children: 'Paid Amount',
                            columnSize: 12,
                            variant: "h5"
                        }],
                    elements: [{
                            type: FormItemTypes.Divider,
                            name: '',
                            columnSize: 12,
                            variant: 'middle'
                        }, {
                            type: FormItemTypes.CardComponent,
                            name: '',
                            // display: 'flex',
                            // flexDirection: 'column',
                            // gap: '16px',
                            columnSize: 12,
                            // borderRadius: '8px',
                            // bgcolor: overlay.white,
                            // bgcolor: overlay.white,
                            // padding: '8px 12px',
                            // sx:{display:'flex', flexDirection:'row', gap:'16px', margin:'8px 12px'},
                            sx: {
                                margin: 2
                            },
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    label: 'Parts Total',
                                    value: '₹ 27,000.00',
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 23
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'base',
                                        color: secondary[700]
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Divider,
                                    name: '',
                                    columnSize: 12,
                                    variant: 'fullWidth'
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    label: 'Basic Amount',
                                    value: '₹ 27,000.00',
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 22
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    value: null,
                                    label: '',
                                    display: 'flex',
                                    columnSize: 12,
                                    justifyContent: 'space-between',
                                    elements: [{
                                            type: FormItemTypes.Box,
                                            name: '',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            // gap: '12px',
                                            columnSize: 6,
                                            borderRadius: '8px',
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    value: 'Discount_1',
                                                    columnSize: 0,
                                                    fontWeight: 'strong',
                                                    color: secondary[500]
                                                }, {
                                                    type: FormItemTypes.IconButton,
                                                    name: '',
                                                    children: /*#__PURE__*/ React.createElement("img", {
                                                        src: EditIcon,
                                                        color: "#6A7682",
                                                        height: '20px',
                                                        width: '20px'
                                                    }),
                                                    columnSize: 0
                                                }]
                                        }, {
                                            type: FormItemTypes.Box,
                                            name: '',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            // gap: '12px',
                                            columnSize: 6,
                                            borderRadius: '8px',
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    value: '-',
                                                    columnSize: 1,
                                                    fontWeight: 'strong',
                                                    color: 'red'
                                                }, {
                                                    type: FormItemTypes.NumberInput,
                                                    name: 'Discount_1Percent',
                                                    label: '',
                                                    value: '',
                                                    placeholder: '0.00',
                                                    columnSize: 5
                                                }, {
                                                    type: FormItemTypes.NumberInput,
                                                    name: 'Discount_1Rupee',
                                                    label: '',
                                                    value: '',
                                                    placeholder: '0.00',
                                                    columnSize: 7
                                                }]
                                        }]
                                }, {
                                    type: FormItemTypes.ContainerItem,
                                    name: '',
                                    value: null,
                                    label: '',
                                    display: 'flex',
                                    columnSize: 12,
                                    justifyContent: 'space-between',
                                    elements: [{
                                            type: FormItemTypes.Box,
                                            name: '',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            // gap: '12px',
                                            columnSize: 6,
                                            borderRadius: '8px',
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    value: 'Discount_2',
                                                    columnSize: 0,
                                                    fontWeight: 'strong',
                                                    color: secondary[500]
                                                }, {
                                                    type: FormItemTypes.IconButton,
                                                    name: '',
                                                    children: /*#__PURE__*/ React.createElement("img", {
                                                        src: EditIcon,
                                                        height: '20px',
                                                        width: '20px'
                                                    }),
                                                    columnSize: 0
                                                }]
                                        }, {
                                            type: FormItemTypes.Box,
                                            name: '',
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            // gap: '12px',
                                            columnSize: 6,
                                            borderRadius: '8px',
                                            elements: [{
                                                    type: FormItemTypes.Typography,
                                                    name: '',
                                                    value: '-',
                                                    columnSize: 1,
                                                    fontWeight: 'strong',
                                                    color: 'red'
                                                }, {
                                                    type: FormItemTypes.NumberInput,
                                                    name: 'Discount_2Percent',
                                                    label: '',
                                                    value: null,
                                                    placeholder: '0.00',
                                                    columnSize: 5,
                                                    sx: {
                                                        borderRadius: '8px 0 0 8px'
                                                    }
                                                }, {
                                                    type: FormItemTypes.NumberInput,
                                                    name: 'Discount_2Rupee',
                                                    label: '',
                                                    value: '',
                                                    placeholder: '0.00',
                                                    columnSize: 7,
                                                    sx: {
                                                        borderRadius: '0'
                                                    }
                                                }]
                                        }]
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    label: ' Charge',
                                    value: '₹ 500.00',
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 29
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    label: 'Taxable Amount',
                                    value: '₹ 20,500.00',
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 20
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    label: 'CGST',
                                    value: '₹ 2600.00',
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 29
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    label: 'SGST',
                                    value: '₹ 2600.00',
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 29
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    label: 'IGST',
                                    value: '₹ 2600.00',
                                    containerProps: {
                                        display: 'inline-flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: 29
                                    },
                                    labelTypographyProps: {
                                        mb: 0,
                                        noWrap: true,
                                        fontWeight: 'medium',
                                        fontSize: 'sm'
                                    },
                                    fontWeight: 'medium',
                                    fontSize: 'sm',
                                    columnSize: 12
                                }]
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    gap: '12px',
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            value: 'Round- off',
                            columnSize: 6,
                            fontWeight: 'strong'
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            value: '0.00',
                            columnSize: 6,
                            alignSelf: '',
                            textAlign: 'right',
                            fontWeight: 'strong',
                            pr: 2
                        }]
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    columnSize: 12,
                    variant: 'fullWidth'
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    gap: '12px',
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            value: 'Net returnable amount',
                            columnSize: 6,
                            fontWeight: 'strong'
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            value: '₹ 1,30,800.00',
                            textAlign: 'right',
                            columnSize: 0,
                            fontWeight: 'strong'
                        }]
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: detailsTab
    }));
};
